import { useEffect, useState } from "react";
import { screens } from "@crehana/ui";
function useMediaQuery(breakpointKey) {
    const mediaQuery = `(min-width: ${screens[breakpointKey]})`;
    const nativeMediaQueryList = "u" > typeof window ? window.matchMedia(mediaQuery) : void 0;
    const [matches, setMatches] = useState(nativeMediaQueryList?.matches);
    useEffect(()=>{
        if (nativeMediaQueryList) {
            const listener = (event)=>{
                setMatches(event.matches);
            };
            if ('function' == typeof nativeMediaQueryList.addEventListener) nativeMediaQueryList.addEventListener('change', listener);
            else if ('function' == typeof nativeMediaQueryList.addListener) nativeMediaQueryList.addListener(listener);
            return ()=>{
                if ('function' == typeof nativeMediaQueryList.removeEventListener) nativeMediaQueryList.removeEventListener('change', listener);
                else if ('function' == typeof nativeMediaQueryList.removeListener) nativeMediaQueryList.removeListener(listener);
            };
        }
    }, [
        nativeMediaQueryList
    ]);
    return {
        matches,
        nativeMediaQueryList
    };
}
const hooks_useMediaQuery = useMediaQuery;
export default hooks_useMediaQuery;
